var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForward10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 26 26",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m5.4 12.8c.1-1.9.9-3.7 2.2-5 1.4-1.3 3.2-2 5.1-1.9 2 .1 3.9 1 5.2 2.5l-2.8 1.6 8.2 5 .2-9.6-3 1.7c-1.8-2.4-4.7-3.9-7.7-4-2.7-.1-5.2.9-7.2 2.7s-3.1 4.3-3.2 7c-.1 4.6 2.9 8.6 7.1 9.9v-3.1c-2.5-1.3-4.2-3.9-4.1-6.8z"
  }), /*#__PURE__*/React.createElement("g", {
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.4 17.6-1.5.7-.3-1.4 2.1-1h1.5v7.8h-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.5 19.8c0 2.4-1 4.1-3 4.1s-2.9-1.8-2.9-4c0-2.3 1-4 3-4 2.1-.1 2.9 1.8 2.9 3.9zm-4.1.1c0 1.8.4 2.6 1.1 2.6s1.1-.9 1.1-2.7c0-1.7-.4-2.6-1.1-2.6-.6 0-1.1.9-1.1 2.7z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward10);
export default __webpack_public_path__ + "static/media/forward_10.9be8fcafc0c0cdabf3006d2119b0b1f6.svg";
export { ForwardRef as ReactComponent };